import * as React from "react";
const SvgZapierSquare = (props) => /* @__PURE__ */ React.createElement("svg", { viewBox: "0 0 400 400", xmlns: "http://www.w3.org/2000/svg", style: {
  width: 120,
  height: "auto"
}, ...props }, /* @__PURE__ */ React.createElement("rect", { x: 0.526367, width: 400, height: 400, fill: "#FF4F00" }), /* @__PURE__ */ React.createElement("rect", { x: 0.526367, width: 400, height: 400, rx: 200, fill: "#FF4F00" }));
export default SvgZapierSquare;
